import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayers2 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.195 14.0549L20.5441 14.8148C20.6825 14.8932 20.7976 15.0069 20.8777 15.1444C20.9578 15.2818 21 15.4381 21 15.5971C21 15.7562 20.9578 15.9124 20.8777 16.0499C20.7976 16.1873 20.6825 16.3011 20.5441 16.3795L12.8994 20.759C12.6259 20.9169 12.3157 21 12 21C11.6843 21 11.3741 20.9169 11.1006 20.759L3.45594 16.3795C3.31752 16.3011 3.2024 16.1873 3.1223 16.0499C3.0422 15.9124 3 15.7562 3 15.5971C3 15.4381 3.0422 15.2818 3.1223 15.1444C3.2024 15.0069 3.31752 14.8932 3.45594 14.8148L4.805 14.0549M12.8994 13.5648C12.6259 13.7226 12.3157 13.8057 12 13.8057C11.6843 13.8057 11.3741 13.7226 11.1006 13.5648L3.45594 9.18524C3.31752 9.1068 3.2024 8.99306 3.1223 8.85561C3.0422 8.71817 3 8.56194 3 8.40286C3 8.24378 3.0422 8.08755 3.1223 7.9501C3.2024 7.81266 3.31752 7.69892 3.45594 7.62048L11.1006 3.24096C11.3741 3.08311 11.6843 3 12 3C12.3157 3 12.6259 3.08311 12.8994 3.24096L20.5441 7.62048C20.6825 7.69892 20.7976 7.81266 20.8777 7.9501C20.9578 8.08755 21 8.24378 21 8.40286C21 8.56194 20.9578 8.71817 20.8777 8.85561C20.7976 8.99306 20.6825 9.1068 20.5441 9.18524L12.8994 13.5648Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgLayers2);
export { ForwardRef as ReactComponent };
